import React, {useState} from 'react';
import {UsePermissions} from "../../hooks/usePermissions";
import {TableDeduccion} from "./components/TableDeduccion";
import {Navigate} from "react-router";
import {ModalNuevoDeduccion} from "./components/ModalNuevoDeduccion";
import {ModalEditarDeduccion} from "./components/ModalEditarDeduccion";

export const DeduccionPage = () => {
    const [permisos] = UsePermissions();
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayeditModal, setDisplayeditModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);

    const editarUsuario= (e) => {
        setFieldEdit({...e});
        setDisplayeditModal(true);
    }

    const crearnuevoUsuario = () => {
        setDisplayNewModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }
    const onHideEdit = () => {
        setDisplayeditModal(false);
        setReload(true);
        resetLoad()
    }

    const resetLoad = () => {
        setTimeout(() =>{
            setReload(false);
        }, 2000)
    }

    return (
        <div className="container-relative">
            {permisos.consultar ? <TableDeduccion reload={reload} obtenerParametrosUser={editarUsuario} nuevoUsuario={crearnuevoUsuario}  />: <Navigate to="/home"/>}
            <ModalNuevoDeduccion show={displayNewModal} hide={onHide}/>
            <ModalEditarDeduccion show={displayeditModal} hide={onHideEdit} fields={fieldEdit}/>
        </div>
    );
};


